/**
 * Storefront image usage notice.
 * Shows usage terms on every protected-image copy/save attempt; copy after acknowledgement.
 */
(function () {
  'use strict';

  var EVENT_DEBOUNCE_MS = 750;
  var LONG_PRESS_MS = 550;
  var MIN_ICON_PX = 120;
  var SUCCESS_CLOSE_MS = 1600;
  var lastShown = 0;
  var lastEventKey = '';
  var popupEl = null;
  var longPressTimer = null;
  var lastProtectedImage = null;
  var pendingAttempt = null;

  var EXCLUDE_SELECTORS = [
    '#header-group',
    'header',
    '.header',
    '.header-logo',
    '.header-logo__image-container',
    'footer',
    '.footer',
    '.footer-group',
    '[role="banner"]',
    '.payment-icons',
    '.predictive-search',
    '.muskle-product-hero__icon-column',
    '.muskle-topmerken-card__logo',
    '.muskle-topmerken-drawer__logo',
    '.icon',
    '.svg-wrapper',
    '.cart-drawer',
  ].join(',');

  var WRAPPER_SELECTORS = [
    '[data-vv-protected-image="true"]',
    '.vv-protected-image-wrap',
    '.muskle-product-hero__gallery-main',
    '.muskle-product-hero__gallery',
    '[data-muskle-gallery]',
    '.muskle-product-hero__media',
    '.muskle-product-hero__media-wrap',
    '.product-media-container',
    '.product-information__media',
    '.card-gallery',
    '.product-card__media',
    '.product-card .card-gallery',
    '.bh-product-card__media',
    '.quick-add__product-media',
  ].join(',');

  var PROTECT_SELECTORS = [
    '[data-vv-protected-image="true"]',
    '.vv-protected-image',
    '.muskle-product-hero__image',
    '.muskle-product-hero__thumb-img',
    '.muskle-product-hero__gallery img',
    '.muskle-product-hero__media img',
    '.muskle-product-hero__gallery-main img',
    '[data-muskle-gallery] img',
    '.card-gallery img',
    '.product-card img',
    '.product-information img',
    '.bh-product-card__img',
    '.bh-product-card__media img',
    '.quick-add img',
  ].join(',');

  var PRODUCT_CONTEXT = [
    '.muskle-product-hero',
    '.product-card',
    '.card-gallery',
    '.product-information',
    '.bh-product-card',
    '[data-vv-protected-image="true"]',
    '[data-muskle-gallery]',
  ].join(',');

  function getConfig() {
    var cfg = window.VanillaVisualeImageProtection || {};
    if (cfg.closeLabel === 'I understand') {
      cfg.closeLabel = 'I understand — copy picture';
    }
    if (!cfg.copyHelper) {
      cfg.copyHelper = 'Copy allowed after acknowledgement.';
    }
    if (!cfg.successMessage) {
      cfg.successMessage = 'Image copied with creator notice acknowledged.';
    }
    if (!cfg.fallbackMessage) {
      cfg.fallbackMessage =
        'Your browser blocked automatic image copy. You may use the normal browser copy option, but keep the visible signature or credit intact.';
    }
    if (cfg.mascotUrl && cfg.mascotUrl.indexOf('.png') !== -1 && !cfg.mascotUrlPatched) {
      cfg.mascotUrl = cfg.mascotUrl.replace('.png', '.jpg');
      cfg.mascotUrlPatched = true;
    }
    if (cfg.muskleLogoUrl && cfg.muskleLogoUrl.indexOf('muskle-logo-white') !== -1) {
      cfg.muskleLogoUrl = cfg.muskleLogoUrl.replace('muskle-logo-white', 'muskle-red-k');
    }
    return cfg;
  }

  function debugLog() {
    var cfg = getConfig();
    if (!cfg.debug) return;
    try {
      console.log.apply(console, ['[VanillaVisualeImageProtection]'].concat(Array.prototype.slice.call(arguments)));
    } catch (e) {
      /* ignore */
    }
  }

  function normalizeAssetUrl(url) {
    if (!url || typeof url !== 'string') return '';
    var u = url.trim();
    if (u.indexOf('//') === 0) return window.location.protocol + u;
    return u;
  }

  function getImageSrc(img) {
    if (!img) return '';
    return normalizeAssetUrl(img.currentSrc || img.src || '');
  }

  function isInsideProductMediaWrapper(el) {
    if (!el || typeof el.closest !== 'function') return false;
    try {
      return !!el.closest(WRAPPER_SELECTORS);
    } catch (e) {
      return false;
    }
  }

  var EDITABLE_SELECTOR =
    'input, textarea, select, [contenteditable]:not([contenteditable="false"]), [role="textbox"], [role="searchbox"], [role="combobox"]';

  function isEditableElement(el) {
    if (!el) return false;
    if (el.nodeType === 3) el = el.parentElement;
    if (!el || el.nodeType !== 1) return false;
    try {
      if (el.isContentEditable) return true;
      if (typeof el.matches === 'function' && el.matches(EDITABLE_SELECTOR)) return true;
      if (typeof el.closest === 'function' && el.closest(EDITABLE_SELECTOR)) return true;
    } catch (e) {
      return false;
    }
    return false;
  }

  function deepestActiveElement() {
    var el = document.activeElement;
    try {
      while (el && el.shadowRoot && el.shadowRoot.activeElement) {
        el = el.shadowRoot.activeElement;
      }
    } catch (e) {
      /* ignore */
    }
    return el;
  }

  function eventPathIsEditable(event) {
    if (!event) return false;
    var nodes = [];
    try {
      if (typeof event.composedPath === 'function') nodes = event.composedPath();
    } catch (e) {
      nodes = [];
    }
    if (!nodes || !nodes.length) nodes = [event.target];
    for (var i = 0; i < nodes.length; i++) {
      if (isEditableElement(nodes[i])) return true;
    }
    return isEditableElement(event.target);
  }

  function isEditableEvent(event, includeActive) {
    if (eventPathIsEditable(event)) return true;
    if (includeActive === false) return false;
    return isEditableElement(deepestActiveElement());
  }

  function selectionLooksLikeText() {
    try {
      var sel = window.getSelection();
      if (!sel || sel.isCollapsed) return false;
      return String(sel).replace(/\s+/g, '').length > 0;
    } catch (e) {
      return false;
    }
  }

  function isExcluded(el) {
    if (!el || typeof el.closest !== 'function') return true;
    try {
      if (el.closest(EXCLUDE_SELECTORS)) return true;
    } catch (e) {
      return true;
    }
    if (el.tagName === 'IMG') {
      var inMedia = isInsideProductMediaWrapper(el);
      var w = el.naturalWidth || el.width || el.clientWidth || 0;
      var h = el.naturalHeight || el.height || el.clientHeight || 0;
      if (!inMedia && w > 0 && h > 0 && w < MIN_ICON_PX && h < MIN_ICON_PX) return true;
    }
    return false;
  }

  function isShopifyProductMediaSrc(src) {
    if (!src || typeof src !== 'string') return false;
    var s = src.toLowerCase();
    if (s.indexOf('/cdn/shop/files/') !== -1) return true;
    if (s.indexOf('/cdn/shop/products/') !== -1) return true;
    if (s.indexOf('/cdn/shop/') !== -1 && s.indexOf('/assets/') === -1 && s.indexOf('/t/') === -1) return true;
    return false;
  }

  function isProtectedImage(img) {
    if (!img || img.tagName !== 'IMG' || isExcluded(img)) return false;
    try {
      if (img.matches(PROTECT_SELECTORS)) return true;
      if (img.closest(PRODUCT_CONTEXT)) return true;
      if (isInsideProductMediaWrapper(img)) return true;
      if (isShopifyProductMediaSrc(img.currentSrc || img.src || '')) {
        if (img.closest('main') && !img.closest(EXCLUDE_SELECTORS)) return true;
      }
    } catch (e) {
      return false;
    }
    return false;
  }

  function imageFromWrapper(el) {
    if (!el || typeof el.closest !== 'function') return null;
    var wrap = el.closest(WRAPPER_SELECTORS);
    if (!wrap) return null;
    if (wrap.tagName === 'IMG') return isProtectedImage(wrap) ? wrap : null;
    var imgs = wrap.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (isProtectedImage(imgs[i])) return imgs[i];
    }
    return null;
  }

  function resolveProtectedImage(target) {
    if (!target || typeof target.closest !== 'function') return null;

    if (target.tagName === 'IMG' && isProtectedImage(target)) return target;

    var img = target.closest('img');
    if (img && isProtectedImage(img)) return img;

    img = imageFromWrapper(target);
    if (img) return img;

    if (target.closest('.muskle-product-hero__gallery-main, [data-muskle-gallery], .muskle-product-hero__media')) {
      var hero = target.closest('.muskle-product-hero');
      if (hero) {
        var main = hero.querySelector('.muskle-product-hero__image, .muskle-product-hero__gallery-main img');
        if (main && main.tagName === 'IMG' && isProtectedImage(main)) return main;
      }
    }

    return null;
  }

  function rememberProtectedImage(img) {
    if (img && isProtectedImage(img)) lastProtectedImage = img;
  }

  function isGenericClipboardTarget(el) {
    if (!el) return true;
    if (el === document || el === window) return true;
    var tag = (el.tagName || '').toUpperCase();
    return tag === 'HTML' || tag === 'BODY';
  }

  function resolveInteractionImage(event, allowRemembered) {
    if (eventPathIsEditable(event)) return null;
    var img = resolveProtectedImage(event && event.target);
    if (!img && allowRemembered && lastProtectedImage && isProtectedImage(lastProtectedImage)) {
      img = lastProtectedImage;
    }
    return img;
  }

  function storeAttempt(img, eventType) {
    if (!img) return;
    pendingAttempt = {
      img: img,
      src: getImageSrc(img),
      alt: (img.alt || img.title || '').trim(),
      eventType: eventType || '',
    };
    debugLog('stored attempt', pendingAttempt.eventType, pendingAttempt.src);
  }

  function resetPopupStatus() {
    if (!popupEl) return;
    var statusEl = popupEl.querySelector('[data-vv-status]');
    if (!statusEl) return;
    statusEl.hidden = true;
    statusEl.setAttribute('hidden', '');
    statusEl.textContent = '';
    statusEl.className = 'vv-protection-notice__status';
  }

  function showStatus(kind, message) {
    if (!popupEl) return;
    var statusEl = popupEl.querySelector('[data-vv-status]');
    if (!statusEl) return;
    statusEl.textContent = message;
    statusEl.className = 'vv-protection-notice__status vv-protection-notice__status--' + kind;
    statusEl.hidden = false;
    statusEl.removeAttribute('hidden');
  }

  function setButtonBusy(busy) {
    if (!popupEl) return;
    var btn = popupEl.querySelector('.vv-protection-notice__close');
    if (!btn) return;
    btn.disabled = !!busy;
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function closePopup() {
    if (!popupEl) return;
    popupEl.hidden = true;
    popupEl.setAttribute('hidden', '');
    setButtonBusy(false);
    resetPopupStatus();
  }

  function showPopup(eventType, img) {
    var now = Date.now();
    storeAttempt(img, eventType);

    if (popupEl && !popupEl.hidden) {
      return;
    }

    if (now - lastShown < EVENT_DEBOUNCE_MS) return;
    lastShown = now;
    lastEventKey = getImageSrc(img);

    ensurePopup();
    resetPopupStatus();
    setButtonBusy(false);

    popupEl.hidden = false;
    popupEl.removeAttribute('hidden');
    var btn = popupEl.querySelector('.vv-protection-notice__close');
    if (btn && typeof btn.focus === 'function') btn.focus();
  }

  function handleNotice(event, actionType) {
    if (eventPathIsEditable(event)) return false;

    var type = actionType || '';
    var isClipboardLike =
      type === 'copy' || type === 'cut' || type === 'keyboard-copy';
    if (isClipboardLike && isEditableElement(deepestActiveElement())) return false;
    if (isClipboardLike && selectionLooksLikeText()) return false;

    var allowRemembered =
      isClipboardLike &&
      (type === 'keyboard-copy' || isGenericClipboardTarget(event && event.target));
    var img = resolveInteractionImage(event, allowRemembered);
    if (!img) return false;

    rememberProtectedImage(img);

    if (event && event.cancelable) event.preventDefault();
    if (event) {
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    }

    debugLog('notice', actionType || 'action', getImageSrc(img));
    showPopup(actionType, img);
    return true;
  }

  function ensurePopup() {
    if (popupEl) return;
    var cfg = getConfig();

    popupEl = document.createElement('div');
    popupEl.className = 'vv-protection-notice';
    popupEl.setAttribute('hidden', '');
    popupEl.setAttribute('role', 'dialog');
    popupEl.setAttribute('aria-labelledby', 'vv-protection-notice-title');
    popupEl.setAttribute('aria-modal', 'true');

    var panel = document.createElement('div');
    panel.className = 'vv-protection-notice__panel';

    var header = document.createElement('div');
    header.className = 'vv-protection-notice__header';

    var brandRow = document.createElement('div');
    brandRow.className = 'vv-protection-notice__brand-row';

    var mascot = document.createElement('img');
    mascot.className = 'vv-protection-notice__mascot';
    mascot.src = normalizeAssetUrl(cfg.mascotUrl || '');
    mascot.alt = 'Creator credit';
    mascot.width = 80;
    mascot.height = 80;
    mascot.loading = 'eager';
    mascot.decoding = 'async';
    mascot.addEventListener('error', function onMascotError() {
      var src = mascot.getAttribute('src') || '';
      if (src.indexOf('.png') !== -1) {
        mascot.src = src.replace('.png', '.jpg');
        return;
      }
      mascot.removeEventListener('error', onMascotError);
    });

    var muskleWrap = document.createElement('div');
    muskleWrap.className = 'vv-protection-notice__muskle-wrap';

    var muskleLogoUrl = normalizeAssetUrl(cfg.muskleLogoUrl || '');
    if (muskleLogoUrl) {
      var muskleLogo = document.createElement('img');
      muskleLogo.className = 'vv-protection-notice__muskle-logo';
      muskleLogo.src = muskleLogoUrl;
      muskleLogo.alt = 'MUSKLE';
      muskleLogo.width = 140;
      muskleLogo.height = 49;
      muskleLogo.loading = 'eager';
      muskleLogo.decoding = 'async';
      muskleLogo.addEventListener('error', function () {
        muskleLogo.remove();
        var fallback = document.createElement('span');
        fallback.className = 'vv-protection-notice__muskle-text';
        fallback.textContent = 'MUSKLE';
        muskleWrap.appendChild(fallback);
      });
      muskleWrap.appendChild(muskleLogo);
    } else {
      var muskleText = document.createElement('span');
      muskleText.className = 'vv-protection-notice__muskle-text';
      muskleText.textContent = 'MUSKLE';
      muskleWrap.appendChild(muskleText);
    }

    brandRow.appendChild(mascot);
    brandRow.appendChild(muskleWrap);

    var headings = document.createElement('div');
    headings.className = 'vv-protection-notice__headings';

    var title = document.createElement('h2');
    title.id = 'vv-protection-notice-title';
    title.className = 'vv-protection-notice__title';
    title.textContent = cfg.title || 'MUSKLE Image Usage Notice';

    var subtitle = document.createElement('p');
    subtitle.className = 'vv-protection-notice__subtitle';
    subtitle.textContent = cfg.subtitle || 'Used by MUSKLE under creative agreement';

    headings.appendChild(title);
    headings.appendChild(subtitle);
    header.appendChild(brandRow);
    header.appendChild(headings);

    var body = document.createElement('div');
    body.className = 'vv-protection-notice__body';

    var paragraphs = cfg.paragraphs;
    if (!paragraphs || !paragraphs.length) {
      if (cfg.message && typeof cfg.message === 'string') {
        paragraphs = cfg.message.split('\n').filter(function (line) {
          return line && String(line).trim() !== '';
        });
      }
    }
    if (!paragraphs || !paragraphs.length) {
      paragraphs = [
        'This product image is creative visual work and is used by MUSKLE with permission.',
        'You may share this image for normal reference or social sharing, as long as the visible signature or credit remains intact.',
        'Removing the signature, editing out credits, or presenting the image as your own work is not allowed.',
        'Product names, packaging, logos, and trademarks remain the property of their respective brands.',
      ];
    }

    for (var i = 0; i < paragraphs.length; i++) {
      var p = document.createElement('p');
      p.className = 'vv-protection-notice__text';
      p.textContent = paragraphs[i];
      body.appendChild(p);
    }

    var footer = document.createElement('div');
    footer.className = 'vv-protection-notice__footer';

    var footerText = document.createElement('p');
    footerText.className = 'vv-protection-notice__footer-text';
    footerText.textContent = cfg.footer || 'Thank you for respecting the creator credit.';

    var helperText = document.createElement('p');
    helperText.className = 'vv-protection-notice__helper';
    helperText.textContent = cfg.copyHelper || 'Copy allowed after acknowledgement.';

    var statusEl = document.createElement('p');
    statusEl.className = 'vv-protection-notice__status';
    statusEl.setAttribute('data-vv-status', '');
    statusEl.hidden = true;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vv-protection-notice__close';
    btn.textContent = cfg.closeLabel || 'I understand — copy picture';

    footer.appendChild(footerText);
    footer.appendChild(helperText);
    footer.appendChild(statusEl);
    footer.appendChild(btn);

    panel.appendChild(header);
    panel.appendChild(body);
    panel.appendChild(footer);
    popupEl.appendChild(panel);

    btn.addEventListener('click', acknowledgeAndCopy);
    popupEl.addEventListener('click', function (event) {
      if (event.target === popupEl) closePopup();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popupEl && !popupEl.hidden) closePopup();
    });

    document.body.appendChild(popupEl);
  }

  function copyAttemptedImage() {
    var attempt = pendingAttempt;
    if (!attempt || !attempt.src) {
      return Promise.reject(new Error('no-image'));
    }

    if (!navigator.clipboard || typeof window.ClipboardItem !== 'function') {
      return Promise.reject(new Error('clipboard-unsupported'));
    }

    return fetch(attempt.src, { mode: 'cors', credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('fetch-failed');
        return response.blob();
      })
      .then(function (blob) {
        var type = blob.type || 'image/png';
        if (type.indexOf('image/') !== 0) type = 'image/png';
        var item = {};
        item[type] = blob;
        return navigator.clipboard.write([new ClipboardItem(item)]);
      });
  }

  function acknowledgeAndCopy() {
    var cfg = getConfig();
    setButtonBusy(true);
    resetPopupStatus();

    copyAttemptedImage()
      .then(function () {
        showStatus(
          'success',
          cfg.successMessage || 'Image copied with creator notice acknowledged.'
        );
        debugLog('copy success', pendingAttempt && pendingAttempt.src);
        window.setTimeout(closePopup, SUCCESS_CLOSE_MS);
      })
      .catch(function () {
        showStatus(
          'fallback',
          cfg.fallbackMessage ||
            'Your browser blocked automatic image copy. You may use the normal browser copy option, but keep the visible signature or credit intact.'
        );
        setButtonBusy(false);
        debugLog('copy fallback', pendingAttempt && pendingAttempt.src);
      });
  }

  function handleCopyOrCut(event) {
    return handleNotice(event, event.type);
  }

  function handleKeyboardCopy(event) {
    if (isEditableEvent(event)) return;
    var key = (event.key || '').toLowerCase();
    if (!(event.ctrlKey || event.metaKey)) return;
    if (key === 'v' || key === 'a' || key === 'x' || event.code === 'KeyV') return;
    if (key !== 'c') return;
    if (selectionLooksLikeText()) return;
    if (!lastProtectedImage || !isProtectedImage(lastProtectedImage)) return;
    handleNotice(event, 'keyboard-copy');
  }

  function markImages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var seen = {};

    function protectImg(img) {
      if (!img || img.tagName !== 'IMG' || !isProtectedImage(img)) return;
      var key = img.src || img.currentSrc || String(Math.random());
      if (seen[key]) return;
      seen[key] = true;
      img.classList.add('vv-protected-image');
      img.setAttribute('draggable', 'false');
      img.setAttribute('data-vv-protected-image', 'true');
      var wrap = img.closest('.muskle-product-hero__gallery-main, .card-gallery, .product-card__media, .bh-product-card__media');
      if (wrap && !wrap.classList.contains('vv-protected-image-wrap')) {
        wrap.classList.add('vv-protected-image-wrap');
      }
    }

    try {
      var nodes = scope.querySelectorAll(PROTECT_SELECTORS);
      for (var i = 0; i < nodes.length; i++) protectImg(nodes[i]);

      var heroImgs = scope.querySelectorAll('.muskle-product-hero img, [data-muskle-gallery] img, .product-card img, .card-gallery img');
      for (var j = 0; j < heroImgs.length; j++) protectImg(heroImgs[j]);
    } catch (e) {
      /* ignore */
    }
  }

  document.addEventListener(
    'pointerover',
    function (event) {
      if (eventPathIsEditable(event)) return;
      var img = resolveProtectedImage(event.target);
      if (img) rememberProtectedImage(img);
    },
    true
  );

  document.addEventListener(
    'mousemove',
    function (event) {
      if (eventPathIsEditable(event)) return;
      var img = resolveProtectedImage(event.target);
      if (img) rememberProtectedImage(img);
    },
    true
  );

  document.addEventListener(
    'focusin',
    function (event) {
      if (eventPathIsEditable(event)) lastProtectedImage = null;
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    function (event) {
      if (eventPathIsEditable(event)) return;
      var img = resolveProtectedImage(event.target);
      if (img) rememberProtectedImage(img);
      if (event.button === 2) handleNotice(event, 'pointerdown-right');
    },
    true
  );

  document.addEventListener(
    'mousedown',
    function (event) {
      if (eventPathIsEditable(event)) return;
      if (event.button === 2) handleNotice(event, 'mousedown-right');
    },
    true
  );

  document.addEventListener('contextmenu', function (event) {
    if (eventPathIsEditable(event)) return;
    handleNotice(event, 'contextmenu');
  }, true);

  document.addEventListener('dragstart', function (event) {
    if (eventPathIsEditable(event)) return;
    handleNotice(event, 'dragstart');
  }, true);

  document.addEventListener('copy', handleCopyOrCut, true);
  document.addEventListener('cut', handleCopyOrCut, true);
  document.addEventListener('keydown', handleKeyboardCopy, true);

  document.addEventListener(
    'selectstart',
    function (event) {
      if (eventPathIsEditable(event)) return;
      if (selectionLooksLikeText()) return;
      if (resolveProtectedImage(event.target)) {
        if (event.cancelable) event.preventDefault();
      }
    },
    true
  );

  document.addEventListener(
    'touchstart',
    function (event) {
      if (event.touches.length !== 1) return;
      if (eventPathIsEditable(event)) return;
      var img = resolveProtectedImage(event.target);
      if (!img) return;
      rememberProtectedImage(img);
      clearTimeout(longPressTimer);
      longPressTimer = setTimeout(function () {
        showPopup('long-press', img);
      }, LONG_PRESS_MS);
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'touchend',
    function () {
      clearTimeout(longPressTimer);
      longPressTimer = null;
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'touchcancel',
    function () {
      clearTimeout(longPressTimer);
      longPressTimer = null;
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'touchmove',
    function () {
      clearTimeout(longPressTimer);
      longPressTimer = null;
    },
    { passive: true, capture: true }
  );

  function init() {
    markImages(document);
    debugLog('init', document.querySelectorAll('.vv-protected-image').length, 'protected images marked');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) markImages(event.target);
  });
})();
